import { render, staticRenderFns } from "./DrawerMenu.vue?vue&type=template&id=6737a28b&scoped=true"
import script from "./DrawerMenu.vue?vue&type=script&lang=js"
export * from "./DrawerMenu.vue?vue&type=script&lang=js"
import style0 from "./DrawerMenu.vue?vue&type=style&index=0&id=6737a28b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6737a28b",
  null
  
)

export default component.exports